export const DEVICE_SELECTION_ERROR_MESSAGE =
  'Invalid selection type for device tool';

export const CONFIGURABLE_SELECTION_ERROR_MESSAGE =
  'Selection does not have configurable options';

export const WIREFRAME_SELECTION_ERROR_MESSAGE =
  'Invalid selection type for wireframe tool';

export const makeTestId = (name: string) =>
  name
    .replace(/\s/g, '_')
    .replace(/[^\w]+/g, '')
    .toLowerCase();
